import { InputMetaStyleInterface } from "./meta_handler_interfaces";

export const metaHandlerDefaultStyle: InputMetaStyleInterface = {
    errorColor: "red",
    saveColor: "green",
    infoColor: "blue",
    metaPaddingClass: "px-4",
};
